import React from 'react';
import { useFormikContext } from 'formik';
import { ReferralPartnerSelect } from '@/components/selects/ReferralPartnerSelect';
import FieldFormControl from '../FieldFormControl';

const ReferralPartnerFormikField = ({ field, disabled }) => {
	const { values, setFieldValue } = useFormikContext();

	return (
		<FieldFormControl {...{ field, disabled, label: field.label }}>
			<ReferralPartnerSelect
				value={values[field.name] ?? ''}
				disabled={disabled}
				onChange={(value) => setFieldValue(field.name, value)}
			/>
		</FieldFormControl>
	);
};

export default ReferralPartnerFormikField;
